import useSetupPremiumCreditToggle from './useSetupPremiumCreditToggle';

const SetupPremiumCreditToggle: React.FunctionComponent = function () {
  useSetupPremiumCreditToggle();
  return <div />;
};

export default SetupPremiumCreditToggle;
